export default __webpack_public_path__ + "static/media/4020.7e98fcc8.png";